export const GainsightEvents = {
  gpuDetected: 'GPU Detected',
  projectSelected: 'Connect Project Selected',
};
